<template>
  <van-overlay show z-index="1000">
    <div ref="content">
      <slot></slot>
    </div>
    <div class="copy-right" ref="footer">
      <copy-right-footer />
    </div>
  </van-overlay>
</template>

<script>
import CopyRightFooter from 'components/dygc-footer-bottom/mobile'

export default {
  name: 'CustomOverlay',
  components: { CopyRightFooter },
  methods: {
    init() {
      const footerHeight = this.$refs.footer.clientHeight
      this.$refs.content.style.height = window.innerHeight - 20 - footerHeight + 'px'
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  }
}
</script>

<style scoped></style>
